import api from './api';

async function fetchParams() {
  return api.get('/calculator/params');
};

async function updateParams(payload) {
  return api.put('/calculator/params', payload);
};

export { fetchParams, updateParams };